import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { i18n } from "../../translate/i18n";
import axios from "axios";
import api from "../../services/api";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
    },
    multFieldLine: {
        display: "flex",
        "& > *:not(:last-child)": {
            marginRight: theme.spacing(1),
        },
    },
    infoBbox: {
        backgroundColor: "rgba(33, 150, 243, 0.1)",
        border: "1px solid rgba(33, 150, 243, 0.3)",
        borderRadius: "4px",
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    infoTitle: {
        color: "#2196f3",
        fontWeight: "bold",
        marginBottom: theme.spacing(1),
        fontSize: "0.9rem",
    },
    infoText: {
        color: theme.palette.text.secondary,
        fontSize: "0.85rem",
        lineHeight: "1.5",
    }
}));

const ContactLidModal = ({ open, onClose }) => {
    const classes = useStyles();
    const { user } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState("");
    const [message, setMessage] = useState("");
    const [whatsappToken, setWhatsappToken] = useState("");

    useEffect(() => {
        if (open) {
            setNumber("");
            setMessage("");
            fetchWhatsapps();
        }
    }, [open]);

    const fetchWhatsapps = async () => {
        try {
            const { data } = await api.get("/whatsapp", { params: { session: 0 } });
            const defaultWpp = data.find((w) => w.isDefault && w.status === "CONNECTED");
            const anyWpp = data.find((w) => w.status === "CONNECTED");

            const selectedWpp = defaultWpp || anyWpp;

            if (selectedWpp && selectedWpp.token) {
                setWhatsappToken(selectedWpp.token);
            }
        } catch (err) {
            console.error("Error fetching whatsapps", err);
        }
    };

    const handleClose = () => {
        onClose();
        setNumber("");
        setMessage("");
    };

    const handleSend = async () => {
        if (number.length < 10) {
            toast.error("Número inválido ou muito curto. Ex: 5511999999999");
            return;
        }
        if (!message) {
            toast.error("Digite uma mensagem para enviar.");
            return;
        }
        if (!whatsappToken) {
            toast.error("Não foi possível obter o Token da API do WhatsApp. Verifique suas conexões.");
            return;
        }

        setLoading(true);
        try {
            let cleanNumber = number.replace(/\D/g, "");
            if (cleanNumber.length === 10 || cleanNumber.length === 11) {
                cleanNumber = "55" + cleanNumber;
            }

            const payload = {
                number: cleanNumber,
                body: message,
                noRegister: true
            };

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/messages/send`, payload, {
                headers: {
                    'Authorization': `Bearer ${whatsappToken}`,
                    'Content-Type': 'application/json'
                }
            });

            toast.success("Mensagem enviada! O contato só será salvo se responder.");
            handleClose();
        } catch (err) {
            toastError(err);
        }
        setLoading(false);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>{i18n.t("contacts.buttons.add")}</DialogTitle>
            <DialogContent dividers>
                <div className={classes.root}>
                    <div className={classes.infoBbox}>
                        <Typography className={classes.infoTitle}>
                            Atenção
                        </Typography>
                        <Typography className={classes.infoText}>
                            O contato só será notificado via WhatsApp e salvo no sistema automaticamente
                            <b> caso ele responda a mensagem ou entre em contato</b>, conforme as novas diretrizes da Meta.
                            Nenhum ticket será aberto neste momento.
                        </Typography>
                    </div>

                    <TextField
                        label="Número (ex: 5511999999999)"
                        autoFocus
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                    />

                    <TextField
                        label="Mensagem Inicial"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        multiline
                        minRows={3}
                        maxRows={5}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        placeholder="Olá, como posso ajudar?"
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    color="secondary"
                    disabled={loading}
                    variant="outlined"
                >
                    {i18n.t("contactModal.buttons.cancel")}
                </Button>
                <Button
                    onClick={handleSend}
                    color="primary"
                    disabled={loading}
                    variant="contained"
                >
                    {loading ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        "Enviar Mensagem"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContactLidModal;
